// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"Cl","innerTile":"Dl","heading":"El","instaTileBtn":"Fl","disabled":"Gl","instaTileElement":"Hl","instagramPic":"Il"};